import { render, staticRenderFns } from "./modalEditTeam.vue?vue&type=template&id=a5b67482&"
import script from "./modalEditTeam.vue?vue&type=script&lang=js&"
export * from "./modalEditTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports